import { useTranslation } from "react-i18next";
import { RowBody } from "../../../../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../../../../components/ToolTip";

function TeilsicherheitsbeiwertTragglied({ teilsicherheitsbeiwertTragglied = 0 }) {
  const { t } = useTranslation("translation");

  return (
    <RowBody
      titleValue={<p>{t("inner.buckling.ofner.parameterTragglied.partialSafetyFactor")}</p>}
      indicesValue={
        <span>
          &gamma;<sub>M</sub>
        </span>
      }
      inputValue={<span className="input">{teilsicherheitsbeiwertTragglied}</span>}
      formulaValue={
        <ToolTip
          id={"TeilsicherheitsbeiwertTragglied"}
          type={IconType.INFO}
          text={t("inner.buckling.ofner.parameterTragglied.partialSafetyFactor_subText")}
        />
      }
    />
  );
}

export default TeilsicherheitsbeiwertTragglied;
